import { render, staticRenderFns } from "./MarkQuestionnaire.vue?vue&type=template&id=13dd3085&scoped=true"
import script from "./MarkQuestionnaire.vue?vue&type=script&lang=js"
export * from "./MarkQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./MarkQuestionnaire.vue?vue&type=style&index=0&id=13dd3085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd3085",
  null
  
)

export default component.exports